module.exports = __webpack_public_path__ + "img/planting_04@2x.9a4f74a.webp";